import { render, staticRenderFns } from "./orderByWorkshop.vue?vue&type=template&id=5d749046&scoped=true"
import script from "./orderByWorkshop.vue?vue&type=script&lang=js"
export * from "./orderByWorkshop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d749046",
  null
  
)

export default component.exports